import { exists, currentPostId, toggleSiblings, toggleClass, fetchAjax, arraySearch, copyToClipboard, setAccordionClasses, isElementInViewport, appendNodeList } from './helpers';
import Accordion from 'accordion-js';
import {Modal} from './modal';

let loading = false;

export class Blog { 

    constructor(selector) {
            if(!selector.length) return;
            this.init(selector);
        }

    init(selector) {
            this.selector = selector;
            this.section = document.querySelector(selector);
            if(!exists(this.section)) return;
            this.form = this.section.querySelector('form');
            if(!exists(this.form)) return;
            this.pagination = this.section.querySelector('.pagination');
            this.nextPage = this.section.querySelector('a[data-navigation="next"]');
            this.isInfinite = this.section.classList.contains('infinite');
            this.infiniteLoader = this.section.querySelector('.infinite-loader');
            this.blogActiveCssClass = acseoPlugin.blogActiveCssClass;
            this.filters = this.section.querySelectorAll('.filter');
            if(!exists(this.filters)) return;
            this.currentPostId = currentPostId();
            this.blockId = this.section.getAttribute('id');
            this.postGrid = this.section.querySelector('.grid');

            this.change();
            this.pages();
            this.resetForm();
            this.triggerResetForm();
            this.resetLocalFilter();
            this.loaded();
            this.selectedFilters();
            this.optionsCounter();
            this.mobileUi();//Unbind this.change, bind this.submit, new Accordion object, new Modal object
            this.toggleFilters();
            this.shareModal();
            this.infiniteScroll(this);
            copyToClipboard();
        } 

    change() {
            if(this.isMobile()) return;
            this.form.addEventListener('change',this.changeHandler.bind(this));
            this.filters.forEach(filter => {
                filter.addEventListener('filter-change',this.changeHandler.bind(this));
            });
        } 

    unbindChangeHandlers() {//Used in mobile filters to replace change by submit
            if(!this.isMobile()) return;
            this.form.removeEventListener('change', this.change(), true);
            this.form.querySelectorAll('input').forEach(input => {
                input.removeEventListener('change', this.change(), true);
            });
            this.filters.forEach(filter => {
                filter.removeEventListener('filter-change', this.change(), true);
            });
        }

    selectedFilters() {
            let args = [];

            this.filters.forEach(filter => {
                  
                let selectedWrapper = filter.querySelector('.selected-filters');
                if(exists(selectedWrapper)) selectedWrapper.textContent = "";

                let label = filter.querySelector('.filter-legend');
                let inputs = filter.querySelectorAll('input:checked');//To extend    

                if(!exists(inputs)) {
                    if(exists(label)) this.updateLabel(label, filter, false);
                    filter.classList.remove(acseoPlugin.blogActiveCssClass);
                    return;
                }
    
                inputs.forEach(input => {
                    if(!exists(input.pattern)) return;
                    if(!exists(input.value)) return;
                    if(!exists(input.name)) return;
                    
                    let key = this.getInputDataKey(input);
                    if(!key) return;
                    if(exists(args,key)) {
                        if(arraySearch(input.value, args[key])) return;
                    }
                    
                    let value = this.Sanitize(input);
                    
                    if(value) {
                        if(exists(label)) this.updateLabel(label, filter, input);
                        args[key] = args[key] || [];
                        args[key].push(value);

                        if(exists(selectedWrapper)) this.createTag(input, value, selectedWrapper, filter);
                        filter.classList.add(acseoPlugin.blogActiveCssClass);
                    }
        
                });
        
            });

            args['paged'] = 1;
            return args;
    
        }

    getInputDataKey(input) {
            if(!exists(input)) return false;
            
            if(exists(input.dataset)) {

                if(exists(input.dataset.rawkey)) return input.dataset.rawkey;
            }

            if(!exists(input.name)) return false;
            const regex = /datas\[(.*?)\]\[\]/;
            const matches = regex.exec(input.name);

            if (!matches) return false;
            if (matches.length < 2) return false;
            return matches[1];
        }

    changeHandler() {
            const args = {
                ...this.selectedFilters({}),
                'pagination' : false,
            };
        
            this.Ajax(args);
        }

    Ajax(datas) {
            if(!datas) return;
            datas['post_id'] = this.currentPostId;
            datas['block_id'] = this.blockId;
            datas = JSON.stringify(Object.assign({},datas));
            let action = 'acseo_blog';
            loading = true;
            fetchAjax(
                action, 
                datas, 
                acseoPlugin.nonce, 
                this.responseHandler, 
                this,
                this.beforeSend,
                this.responseComplete,
                () => loading = false
            );
        }

    responseHandler(responseText, datas, that) {
            if(!exists(responseText)) console.log('No response');

            const htmlDoc = new DOMParser().parseFromString(responseText, 'text/html');
            const newSection = htmlDoc.getElementById(that.section.id);

            if(datas['pagination'] === true && that.isInfinite === true) {
                const pagination = newSection.querySelector('.pagination');
                const newPosts = newSection.querySelectorAll('.item');
                that.pagination.replaceWith(pagination);
                appendNodeList(that.postGrid, newPosts);
            } else {
                that.section.replaceWith(newSection);
            }               
        }

    beforeSend(that, datas) {
            if(datas['pagination'] === true && that.isInfinite === true) {
                toggleClass(that.infiniteLoader, that.blogActiveCssClass);
            } else {
                toggleClass(that.section, that.blogActiveCssClass);
            }
        }

    responseComplete(that, datas) { 
            if(datas['pagination'] === true && that.isInfinite === true) {
                toggleClass(that.infiniteLoader, that.blogActiveCssClass);
                that.pages();
                that.infiniteScroll(that);
            } else {
                that.init('#' + that.section.id);
            }
        }

    submit() { 
            this.form.addEventListener('submit',function(e){
                e.preventDefault();

                let action = this.form.getAttribute('action');
                if(exists(action)) {  
                    this.form.submit();
                    return; 
                }

                const args = {
                    ...this.selectedFilters({}),
                    'pagination' : false,
                };
                this.Ajax(args);
                
            }.bind(this));
        }

    loaded() {
            document.addEventListener("DOMContentLoaded", function(e){
                this.selectedFilters();
            }.bind(this));
        }

    /**
     * Pagination routines
     */
    pages() {//Check for page  navigation
            if(!exists(this.pagination)) return;
            const pages = this.pagination.querySelectorAll('a');
            if(!exists(pages)) return;
            
            pages.forEach(page => {
                this.page(page);
            });
        }

    page(page) {//Attach event to page links
            page.addEventListener('click',function(e){
                e.preventDefault();

                let pageNumber = e.target.dataset.page;
                if(!exists(pageNumber)) return;
                
                const args = {
                    ...this.selectedFilters({}),
                    'pagination' : true,
                };
                
                pageNumber = parseInt(pageNumber, 10);
                if (!isNaN(pageNumber)) args['paged'] = pageNumber;

            
                this.Ajax(args);//
                

            }.bind(this));
        }

    currentPage() {
            let page = document.querySelector('.page-numbers.current');
            if(!exists(page)) return 1;
            let pageNumber = parseInt(page.innerText, 10);
            if (!isNaN(pageNumber)) return pageNumber;
            return 1;
        }

    infiniteScroll(that) {
            if (that.isInfinite !== true) return;
            if (!exists(that.postGrid)) return;
            
            let scrollHandler = function () {
                    if(loading === true) return;

                    that.postGrid = document.querySelector('.grid');
                    if(!isElementInViewport(that.postGrid, 30, 'bottom')) return;
                    
                    //window.removeEventListener('scroll', scrollHandler);

                    that.pagination = document.querySelector('.pagination');
                    that.nextPage = document.querySelector('a[data-navigation="next"]');

                    if(!exists(that.nextPage)) {
                        if(exists(that.infiniteLoader)) {
                            that.infiniteLoader.classList.remove(that.blogActiveCssClass);
                            
                        }
                        return;
                    }

                    let pageNumber = that.nextPage.dataset.page;
            
                    const args = {
                        ...that.selectedFilters({}),
                        'pagination' : true,
                    };
                    
                    pageNumber = parseInt(pageNumber, 10);
                    if (!isNaN(pageNumber)) args['paged'] = pageNumber;

                    //console.log('page: '+pageNumber);
                    //console.log('length: '+ that.postGrid.querySelectorAll('.item').length);
                    that.Ajax(args);
                }
            
            window.removeEventListener('scroll', scrollHandler);
            window.addEventListener('scroll', scrollHandler);
        }

    /**
     * Reset routines
     */
    resetForm() {
            const that = this;
            this.form.addEventListener('reset',function(e){
                e.preventDefault();
                e.stopPropagation();
                this.form.removeEventListener('change', that.changeHandler); 

                this.filters.forEach(filter => {
                    let inputs = filter.querySelectorAll('input');
                    if(!exists(inputs)) return;
                    inputs.forEach(input => {
                        if(input.checked) {
                            input.checked = false;
                        }  
                    });
                    
                });

                let args = [];
                args['paged'] = 1;

                this.Ajax(args);

            }.bind(this));
        }

    triggerResetForm() {
            let resets = document.querySelectorAll('.reset-filters');
            if(!exists(resets)) return;
            resets.forEach(reset => {
                reset.addEventListener('click',function(e){
                    
                    e.preventDefault();
                    let formId = reset.getAttribute('aria-controls');
            
                    if(!exists(formId)) return;

                    let form = document.querySelector('#'+formId);
                    
                    if(!exists(form)) return;

                        
                    let event = new Event('reset');
                    form.dispatchEvent(event);
                    return;
                });
        });
        }

    resetLocalFilter() {
            this.filters.forEach(filter => {
                let resets = filter.querySelectorAll('.reset-local-filter');
                if(!exists(resets)) return;
                
                resets.forEach(reset => {
                    reset.addEventListener('click',function(e){
                        e.preventDefault();


                        let inputs = filter.querySelectorAll('input');
                        if(!exists(inputs)) return;
                        
                        inputs.forEach( (input,i) => {
                            if(input.checked) {
                                input.checked = false;
                                input.removeAttribute('checked');
                            }  
                        });
            
                        let event = new Event('filter-change');
                        filter.dispatchEvent(event);

                    }.bind(this));
                });
            });
        }

    /**
     * UI Routines
     */
    updateLabel(label, filter, input = false) {
            if(!exists(label)) return;
            let defaultText = filter.querySelector('.toggle-filter').dataset.default;
            
            if(exists(input.value)) {
                if(input.nextElementSibling.innerText) label.textContent = input.nextElementSibling.innerText;
                return;
            }

            if(exists(defaultText)) label.textContent = defaultText;
            return;
        }

    createTag( input, value, selectedWrapper, filter) {
            if(!exists(selectedWrapper)) return;

            let tag = document.createElement('a');
            tag.setAttribute('href','#'+input.id);
            tag.setAttribute('class','term-'+value);
            tag.setAttribute('rel','nofollow');
            tag.setAttribute('data-value',value);

            let label = input.nextElementSibling.innerText;
            if(exists(label)) tag.innerHTML = '<span class="selected-filter">'+label+'<span class="remove"></span></span>';

            tag.querySelector('.remove').addEventListener('click',function(e){
                e.preventDefault();
                e.stopPropagation();
                
                input.checked = false;
                let event = new Event('change');
                input.dispatchEvent(event);
                tag.remove();
                
                if(selectedWrapper.childNodes.length === 0) {
                    selectedWrapper.classList.remove(this.blogActiveCssClass);
                    this.toggleDefaultValue(filter, true);
                }
            });

            selectedWrapper.appendChild(tag);
            filter.querySelector('.filter-legend').textContent = label;

        }

    toggleFilters() {
            if(this.isMobile()) return;

            let modals = document.querySelectorAll('.filter-modal');
            if(!exists(modals)) return;
        
            this.filters.forEach(filter => {
            
                let buttons = filter.querySelectorAll('.toggle-filter');
                if(!exists(buttons)) return;
                
                buttons.forEach(button => {
                    
                    let target_id = button.dataset.filter;
                    let el = document.querySelector(target_id);
                    if(!exists(el)) return;
                        
                    button.addEventListener('click',function(e){
                        e.preventDefault();
                        e.stopPropagation();
                        
                        toggleSiblings(el, modals);
                        toggleSiblings(button, buttons);

                    }.bind(this));
                    
                });
                
            });
        
            window.addEventListener('click',function() {
                modals.forEach(modal => {modal.classList.remove(this.blogActiveCssClass);});
            });
        
        } 

    /**
     * Mobile UI Routines
     */
    isMobile() {
            return window.innerWidth < 1024 ? true : false;
        }

    mobileUi() {
            if(!this.isMobile()) return;
            this.unbindChangeHandlers();
            this.submit();
            this.filters.forEach(filter => {
                filter.addEventListener('filter-change', function(){
                    this.form.dispatchEvent(new Event('submit'));
                }.bind(this), true);
            });
            new Modal({
                modalSelector: this.selector + ' .mobile-wrapper',
                openSelector: this.selector + ' .open-filters',
                closeSelector: this.selector + ' .close-filters',
            });
                
            setAccordion({//accordion-js does not work properly with custom selectors
                accordions: this.filters,
                triggerSelector: '.toggle-filter',
                panelSelector:'.filter-modal',
            });

            new Accordion(this.selector + ' .form-content', {
                duration: 400,
                showMultiple: false,
            });   
        }

    optionsCounter() {
            const counterWrapper = this.section.querySelector('.count');
            const counter = this.section.querySelector('.count .number');
            if(!exists(counter)) return;
            counter.textContent = this.countCheckedInputs();
            if(this.countCheckedInputs() > 0) {
                if(!counterWrapper.classList.contains(this.blogActiveCssClass)) counterWrapper.classList.add(this.blogActiveCssClass);
            } else {
                counterWrapper.classList.remove(this.blogActiveCssClass);
            }
        }

    countCheckedInputs() {
            let count = 0;
            this.filters.forEach(filter => {
                let inputs = filter.querySelectorAll('input:checked');
                if(!exists(inputs)) return;
                count += inputs.length;
            });

            return count;
        }

    shareModal() {
            new Modal({
                modalSelector: this.selector + ' .share-modal',
                openSelector: this.selector + ' .open-share',
                closeSelector: this.selector + ' .close-share',
                createOverlay: false,
            });
        }

    /**
     * Compare pattern against configuration patterns
     * Return false if pattern differs
     * If patterns match, check if input value match pattern
     * @param input 
     * @returns value
     */
    Sanitize(input) {      
            let value = false;
            let textInputRegex = acseoPlugin.text_input_regex;
            let numberInputRegex = acseoPlugin.number_input_regex;

            if(input.pattern == textInputRegex) {
                let regExp = new RegExp(textInputRegex);
                if(regExp.test(input.value)) value = String(input.value);
            }

            if(input.pattern == numberInputRegex) {
                let regExp = new RegExp(numberInputRegex);
                if(regExp.test(input.value)) value = Number(input.value);
            }
            
            return value;
        }

}